import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-thank-you',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './thank-you.component.html',
  styleUrl: './thank-you.component.scss'
})
export class ThankYouComponent implements OnInit {
  ngOnInit(): void {
    // Optional: auto-redirect after 30 seconds
    // setTimeout(() => this.router.navigateByUrl('/login'), 30_000);
  }
}
